<template>
  <div
    class="grid-details"
    data-qa="grid-details"
    :style="{
      'grid-template-columns': `${labelColumnWidth} auto`,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import {
  type CSSProperties,
  computed,
} from 'vue';

const props = withDefaults(defineProps<{
  labelWidth?: CSSProperties['width'],
}>(), {
  labelWidth: '250px',
});

// Vue adds the unit to numbers only for properties it binds directly, not inside a value.
const labelColumnWidth = computed<string>(() => (typeof props.labelWidth === 'number' ? `${props.labelWidth}px` : props.labelWidth));
</script>

<style scoped lang="scss">
.grid-details {
  display: grid;
  gap: var(--gap-section);
}
</style>
